import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, Events, ToastController } from 'ionic-angular';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';

import { ViewController } from 'ionic-angular';


@Component({
  selector: 'page-reset-password',
  templateUrl: 'reset-password.html',
})
export class ResetPasswordPage {
  newpasswordType_2: string;
  [x: string]: any;
  summaryData: any;
  email_id: any = '';
  old_password: any = '';
  new_password: any = '';
  con_password: any = '';
  passwordType: string = 'password';
  newpasswordType: string = 'password';
  passwordIcon1: string = 'eye-off';
  passwordIcon2: string = 'eye-off';
  passwordReset: string;
  resetPasswordCtrl: any;
  fieldStatus: any = true;
  constructor(public navCtrl: NavController, private popup: AlertController, public viewCtrl: ViewController, public navParams: NavParams, private EncrDecrService: EncrDecrServiceProvider, public events: Events, public toastController: ToastController,public configureService: ConfigureServiceProvider) {

  }
  ngAfterViewInit() {
    var pwd_resetUrl = window.location.search.substring(1).split('&')[2];
    if (pwd_resetUrl) {
      console.log(pwd_resetUrl);
      this.passwordReset = pwd_resetUrl.split("=")[1];
      this.resetPassword();
    }
  }
  resetPassword() {
    this.resetPasswordCtrl = this.popup.create({
      title: 'Reset Password',
      cssClass: 'resetPassword_Main',
      inputs: [
        {
          name: 'emailID',
          placeholder: 'Email ID',
          id: 'emailId'
        },
        {
          name: 'oldPassword',
          placeholder: 'Old Password',
          type: 'password',
          id: 'oldPassword'
        },

        {
          name: 'newPassword',
          placeholder: 'New Password',
          type: 'password',
          id: 'newPassword'
        },
        {
          name: 'confirmPassword',
          placeholder: 'Confirm Password',
          type: 'password',
          id: 'confirmPassword'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');

          }
        },
        {
          text: 'Save',
          handler: data => {
            console.log('Save clicked');
            this.email_id = data.emailID;
            this.old_password = data.oldPassword;
            this.new_password = data.newPassword;
            this.con_password = data.confirmPassword;
            this.forgotPassword()
          }
        }
      ]
    });
    this.resetPasswordCtrl.present();
    this.resetPasswordCtrl.onDidDismiss(function () {
    });
  }

  forgotPassword() {
    if (this.email_id == "" || 0) {
      alert("Please Enter Email");
    } else if (this.old_password == "" || 0) {
      alert("Please Enter Old Password");
    } else if (this.new_password == "" || 0) {
      alert("Please Enter New Password");
    } else if (this.con_password == "" || 0) {
      alert("Please Enter Confirm Password");
    } else {
      this.proccessForgotPassword()
    }
  }

  proccessForgotPassword() {
    var old_password = this.EncrDecrService.set('BETSYENC123$$', this.old_password);
    var new_password = this.EncrDecrService.set('BETSYENC123$$', this.new_password);
    var confirm_password = this.EncrDecrService.set('BETSYENC123$$', this.con_password);

    let data = {};
    data = {
      "email": this.email_id,
      "Old_Password": old_password,
      "New_Password": new_password,
      "Confirm_Password": confirm_password,
      "userid": this.configureService.getLoginUserID(),
      "rptname": "Reps581",
      "client": "Master74634"
    }
    this.configureAPIService.pushRequest(data, this.forgotPasswordResponse);
    this.new_password = '';
    this.con_password = '';
  }

  forgotPasswordResponse = ((result) => {
    console.log(result["_POST_AddMethodResult"]);
    if(result == "SUCCESS"){
      this.resetPasswordCtrl.dismiss();
      let successAlert: any = '';
      successAlert = this.popup.create({
        title: 'Reset Success',
        subTitle: 'Reset Password successfully. You will be logged out from your account. Please, Login again.',
        buttons: [{
          text: 'Ok',
          handler: () => {
            console.log('Confirm Ok');
          }
        }]
      });

      successAlert.present();
      let __this: any = this;
      successAlert.onDidDismiss(function () {
        __this.logout();
      })
      this.resetPasswordCtrl.onDidDismiss(function () {
      });
    }else if (result.Result == "FAILED") {
      var pass_result = result.message;
      alert(pass_result);
      this.resetPassword();
    }
  }) 

  ionViewDidLoad() {
    console.log('ionViewDidLoad ResetPasswordPage');
  }
  public close() {
    this.viewCtrl.dismiss();
  }

  hideShowPassword_1() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon1 = this.passwordIcon1 === 'eye-off' ? 'eye' : 'eye-off';
  }
  hideShowPassword_2() {
    this.newpasswordType = this.newpasswordType === 'text' ? 'password' : 'text';
    this.passwordIcon2 = this.passwordIcon2 === 'eye-off' ? 'eye' : 'eye-off';
  }
}



// WEBPACK FOOTER //
// ./src/pages/reset-password/reset-password.ts